import React from 'react';

const InfoBar = ({
  children,
  border,
  center = false,
}: {
  children: React.ReactNode;
  border?: boolean;
  center?: boolean;
}) => {
  return (
    <div
      className={`col-12 bg-light p-3 mb-3 text-${center ? 'center' : 'left'} ${
        border ? 'border' : ''
      }`}
    >
      {children}
    </div>
  );
};

export default InfoBar;
